<template>
  <div class="captcha-mask">
    <div class="captcha-modal">
      <h3>请输入图片验证码</h3>
      <img :src="img" class="captcha-img" @click="refresh" alt="验证码"/>
      <input v-model="code" placeholder="输入验证码"/>
      <div class="captcha-btns">
        <button class="btn-ghost" @click="$emit('close')">取消</button>
        <button class="btn-primary" @click="confirm">确认</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['img'],
  data() {
    return { code: '' }
  },
  methods: {
    refresh() { this.$emit('refresh') },
    confirm() {
      if (!this.code) return alert('请输入验证码')
      this.$emit('confirm', this.code)
    }
  }
}
</script>

<style scoped>
.captcha-mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.captcha-modal {
  background: var(--surface);
  padding: 28px;
  border-radius: var(--radius-lg);
  width: 320px;
  text-align: center;
  box-shadow: var(--shadow-hover);
  border: 1px solid var(--border-light);
}

.captcha-modal h3 {
  font-size: 16px;
  margin-bottom: 16px;
  color: var(--text);
}

.captcha-img {
  width: 100%;
  height: 90px;
  object-fit: cover;
  cursor: pointer;
  border-radius: var(--radius-sm);
  margin-bottom: 12px;
  border: 1px solid var(--border);
}

.captcha-modal input {
  width: 100%;
  height: 40px;
  padding: 0 12px;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  font-size: 14px;
  box-sizing: border-box;
  margin-bottom: 16px;
  background: var(--surface-2);
  color: var(--text);
}

.captcha-btns {
  display: flex;
  gap: 10px;
}

.captcha-btns button {
  flex: 1;
  height: 40px;
}
</style>
